import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Box, Container } from '@mui/material';

/**
 * Public Layout for the checkout page and other public routes
 */
const PublicLayout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Main content */}
      <Container 
        component="main" 
        maxWidth="md" 
        sx={{ 
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Outlet /> {/* Render child routes */}
      </Container>

      {/* Footer */}
      <Box 
        component="footer" 
        sx={{ 
          py: 3, 
          mt: 'auto',
          textAlign: 'center',
          borderTop: '1px solid #eaeaea',
          backgroundColor: '#f9f9f9'
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center' }}>
            &copy; {new Date().getFullYear()} Creatos Inc. All rights reserved.
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default PublicLayout;